import script from "./Tab.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab.vue?vue&type=script&setup=true&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=6fdebb9f&lang=scss"

const __exports__ = script;

export default __exports__